import { jsxs, jsx } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { TextBox, SuggestionListWidget } from "@brandclub/bc-widgets";
import { useConversationStarters } from "../../utils/hooks/useConversationStarters.js";
const ConciergeWelcomeEmbeddedComponent = ({
  displayQueries,
  isLoadingSuggestedQueries,
  onSearch,
  pageContext,
  apiBaseUrl
}) => {
  const pageType = pageContext == null ? void 0 : pageContext.pageType;
  const stacklineSku = pageContext == null ? void 0 : pageContext.stacklineSku;
  const { questions: contextQueries, isLoading: isLoadingContextQueries } = useConversationStarters({
    stacklineSku,
    apiBaseUrl,
    enabled: pageType === "pdp" && !!stacklineSku
  });
  const queriesToShow = useMemo(
    () => contextQueries.length > 0 ? contextQueries : displayQueries,
    [contextQueries, displayQueries]
  );
  const isLoading = useMemo(
    () => isLoadingContextQueries || (pageContext == null ? void 0 : pageContext.pageType) === "pdp" && isLoadingSuggestedQueries,
    [isLoadingContextQueries, pageContext == null ? void 0 : pageContext.pageType, isLoadingSuggestedQueries]
  );
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px 16px",
        textAlign: "center",
        width: "100%",
        height: "100%",
        boxSizing: "border-box",
        overflow: "auto"
      },
      children: [
        /* @__PURE__ */ jsx("div", { style: { marginBottom: "20px" }, children: /* @__PURE__ */ jsx("div", { style: { margin: "0 0 8px 0" }, children: /* @__PURE__ */ jsx(
          TextBox,
          {
            widgetId: "concierge-welcome-message",
            displayName: "Welcome Message",
            initialState: {
              content: (pageContext == null ? void 0 : pageContext.pageType) === "pdp" ? "Get expert advice on this product" : "Let us help you find what you've been looking for.",
              fontSize: 24,
              fontWeight: "bold",
              color: {
                type: "theme",
                value: "primary"
              },
              textAlign: "center",
              lineHeight: 1.2,
              letterSpacing: 0,
              textTransform: "none"
            }
          }
        ) }) }),
        queriesToShow.length > 0 && !isLoading && /* @__PURE__ */ jsx(SuggestionListWidget, { widgetId: "concierge-suggestion-list", displayName: "Suggestion List", children: (state, resolveColor) => /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: `${state.containerGap}px`,
              maxWidth: "100%"
            },
            children: queriesToShow.slice(0, 4).map((query, index) => /* @__PURE__ */ jsx(
              "button",
              {
                onClick: () => {
                  onSearch(query);
                },
                style: {
                  padding: `${state.pillPaddingY}px ${state.pillPaddingX}px`,
                  borderRadius: `${state.pillBorderRadius}px`,
                  border: `${state.pillBorderWidth}px solid ${resolveColor(state.pillBorderColor)}`,
                  backgroundColor: resolveColor(state.pillBgColor),
                  color: resolveColor(state.pillTextColor),
                  fontSize: `${state.pillFontSize}px`,
                  fontWeight: state.pillFontWeight === "normal" ? 400 : state.pillFontWeight === "medium" ? 500 : state.pillFontWeight === "semibold" ? 600 : 700,
                  fontFamily: state.pillFontFamilyCss || "inherit",
                  cursor: "pointer",
                  textAlign: "left",
                  transition: "all 0.2s ease",
                  width: "100%"
                },
                onMouseEnter: (e) => {
                  e.currentTarget.style.backgroundColor = resolveColor(state.pillBgColorHover) || resolveColor(state.pillBgColor);
                },
                onMouseLeave: (e) => {
                  e.currentTarget.style.backgroundColor = resolveColor(state.pillBgColor);
                },
                children: query
              },
              index
            ))
          }
        ) })
      ]
    }
  );
};
const ConciergeWelcomeEmbedded = memo(ConciergeWelcomeEmbeddedComponent);
export {
  ConciergeWelcomeEmbedded
};
//# sourceMappingURL=ConciergeWelcomeEmbedded.js.map
